module.exports = __webpack_public_path__ + "static/media/thumbnail-placeholder.03292c63.svg";